import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";

import { ConsentProvider } from "@/context/ConsentContext";
import AnalyticsLoader from "@/components/AnalyticsLoader";
import CookieConsent from "@/components/CookieConsent";

function App() {
  return (
    <ConsentProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <AnalyticsLoader />
        <CookieConsent />
      </div>
    </ConsentProvider>
  );
}

export default App;